import { render } from "./RestaurantHeader.vue?vue&type=template&id=b1bee6e0"
import script from "./RestaurantHeader.vue?vue&type=script&lang=js"
export * from "./RestaurantHeader.vue?vue&type=script&lang=js"

import "./RestaurantHeader.vue?vue&type=style&index=0&id=b1bee6e0&lang=css"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__